window.addEventListener('load', function () {

    let firstClose = false;

    // Keep focus inside modal
    function trapFocus(element) {
        var focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
        var firstFocusableEl = focusableEls[0];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];
        var KEYCODE_TAB = 9;

        element.addEventListener('keydown', function (e) {
            var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) /* shift + tab */ {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else /* tab */ {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        });
    }

    var stopVideo = function (element) {
        var iframe = element.querySelector('iframe');
        var video = element.querySelector('video');
        if (iframe) {
            var iframeSrc = iframe.src;
            iframe.src = '';
        }
        if (video) {
            video.pause();
        }
    };

    function openVideo(videoID) {
        const videoContent = document.getElementById(videoID),
            openButton = document.querySelector('.video-popup__open[aria-controls="' + videoID + '"]'),
            closeButton = document.querySelector('.video-popup__close[aria-controls="' + videoID + '"]');

        let videoIframe = document.querySelector('#' + videoID + " iframe");

        if (!firstClose && videoIframe) {
            videoContent.dataset.src = videoIframe.src;
        }

        if (videoContent && openButton && closeButton) {
            openButton.setAttribute('aria-expanded', true);
            closeButton.setAttribute('aria-expanded', false);
            trapFocus(videoContent);
            setTimeout(() => {
                //closeButton.focus(); // wait for visibility css
            }, 500);
            videoContent.classList.add('video-popup__modal--open');
            if (firstClose) {
                if( ! videoIframe ) {
                    videoIframe = document.querySelector('#' + videoID + " iframe");
                }
                console.log(videoIframe);
                videoIframe.src = videoContent.dataset.src;
            }
        }
    }

    function closeVideo(videoID) {
        const videoContent = document.getElementById(videoID),
            openButton = document.querySelector('.video-popup__open[aria-controls="' + videoID + '"]'),
            closeButton = document.querySelector('.video-popup__close[aria-controls="' + videoID + '"]');
        if (videoContent && openButton && closeButton) {
            closeButton.setAttribute('aria-expanded', true);
            openButton.setAttribute('aria-expanded', false);
            videoContent.classList.remove('video-popup__modal--open');
            stopVideo(videoContent);
        }
    }

    const videoPopupsButtons = document.querySelectorAll('.video-popup__toggle');
    [...videoPopupsButtons].forEach(videoPopupButton => {
        videoPopupButton.addEventListener('click', e => {
            e.preventDefault();
            if (e.target.getAttribute('aria-controls')) {
                const openClose = e.target.classList.contains('video-popup__open');
                if (openClose) {
                    openVideo(e.target.getAttribute('aria-controls'));
                    document.querySelector('html').classList.add('no-scroll');
                } else {
                    closeVideo(e.target.getAttribute('aria-controls'));
                    document.querySelector('html').classList.remove('no-scroll');
                    if (!firstClose) {
                        firstClose = true;
                    }
                }
            }
        });
    });

    const videoTranscriptButtons = document.querySelectorAll('.video-popup__transcript-toggle');
    [...videoTranscriptButtons].forEach(videoTranscriptButton => {
        videoTranscriptButton.addEventListener('click', e => {
            e.preventDefault();
            if (e.target.getAttribute('aria-controls')) {
                const transcript = document.getElementById(e.target.getAttribute('aria-controls'));
                if (transcript) {
                    if (transcript.getAttribute('hidden')) {
                        e.target.setAttribute('aria-expanded', true);
                        transcript.removeAttribute('hidden');
                    } else {
                        e.target.setAttribute('aria-expanded', false);
                        transcript.setAttribute('hidden', true);
                    }
                }
            }
        });
    });

});